export const rndProps = {
  bounds: '#dataView',
  dragAxis: 'y' as 'y' | 'x' | 'both' | 'none',
  enableResizing: {
    bottom: true,
    bottomLeft: false,
    bottomRight: false,
    left: false,
    right: false,
    top: true,
    topLeft: false,
    topRight: false,
  },
  resizeHandleClasses: { bottom: 'resize-handle', top: 'resize-handle' },
  resizeHandleStyles: {
    bottom: { bottom: '-2px', height: '5px' },
    top: { height: '5px', top: '-2px' },
  },
}
